import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {MenuItemSelection} from '../../_models/menu-item-selection';
import {OrderItem} from '../../_models/order-item';
import {MenuItem} from '../../_models/menu-item';
import {MenuSelectionItem} from '../../_models/menu-selection-item';
import {SubscriberComponent} from '../subscriber.component';
import {MenuItemInventoryService} from '../../_services/menu-item-inventory.service';
import {MenuItemInventory} from '../../_models/menu-item-inventory';
import {MenuItemInventoryActionComponent} from '../menu-item-inventory-action/menu-item-inventory-action.component';
import {OrderItemSelection} from '../../_models/order-item-selection';
import {MenuSelectionPrice} from '../../_models/menu-selection-price';
import {DisplayMenuItemModalComponent} from '../display-menu-item-modal/display-menu-item-modal.component';

@Component({
    selector: 'bb-display-order-item-selection',
    templateUrl: './display-order-item-selection.component.html',
    styleUrls: ['./display-order-item-selection.component.scss'],
})
export class DisplayOrderItemSelectionComponent extends SubscriberComponent implements OnInit, OnChanges {
    @Input() orderItem: OrderItem;
    @Input() menuItem: MenuItem;
    @Input() selection: MenuItemSelection;
    @Input() terminalMode: boolean;

    orderItemSelection: OrderItemSelection;
    selectionPrices: MenuSelectionPrice[];
    backOfHouseInventories: MenuItemInventory[];

    constructor(
        private menuItemInventoryService: MenuItemInventoryService,
        private modalController: ModalController
    ) {
        super();
    }

    ngOnInit() {
        this.setOrderItemSelection();

        this.subscribe(this.menuItemInventoryService.backOfHouseInventory.subscribe(inventory => {
            if (!!this.menuItem && !!this.menuItem.prices) {
                this.backOfHouseInventories = !!inventory && !!this.menuItem
                    ? inventory.filter(i => i.menuItem.id === this.menuItem.id)
                    : [];
            }
        }));
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!!changes.orderItem) {
            this.setOrderItemSelection();
        }
    }

    setOrderItemSelection() {
        if (!!this.orderItem && !!this.orderItem.selections) {
            this.orderItemSelection = this.orderItem.selections.find(s => s.menuItemSelection.id === this.selection.id);
        }
    }

    async openItemModal(menuSelectionItem: MenuSelectionItem, selection: MenuItemSelection) {
        if (menuSelectionItem.selected && menuSelectionItem.selectionCount === 0) {
            menuSelectionItem.selected = false;
        }

        const modal = await this.modalController.create({
            component: DisplayMenuItemModalComponent,
            componentProps: {
                menuItem: menuSelectionItem.menuItem,
                parentOrderItem: this.orderItem,
                parentMenuSelectionItem: menuSelectionItem,
                parentSelection: selection,
                terminalMode: this.terminalMode
            },
            cssClass: 'menu-item-modal',
            canDismiss: true,
            presentingElement: document.querySelector(`#header-${this.menuItem.id}`)
        });
        await modal.present();
    }

    async adjustInventory(event, menuItemInventory: MenuItemInventory) {
        if (!!event) {
            event.stopPropagation();
        }
        const modal = await this.modalController.create({
            component: MenuItemInventoryActionComponent,
            componentProps: {
                menuItemInventory,
                backOfHouseInventory: !!this.backOfHouseInventories
                    ? this.backOfHouseInventories.find(i => i.menuItem.id === menuItemInventory.menuItem.id
                        && ((!i.menuItemPrice && !menuItemInventory.menuItemPrice)
                            || (!!i.menuItemPrice && !!menuItemInventory.menuItemPrice && i.menuItemPrice.id === menuItemInventory.menuItemPrice.id)))
                    : null
            },
            cssClass: 'inventory-modal'
        });

        modal.onDidDismiss().then(dataReturned => {
            if (!!dataReturned && !!dataReturned.data) {
                this.menuItemInventoryService.setEvent(dataReturned.data);
            }
        });

        await modal.present();
    }

    displaySelectionPricingInfo(selection: MenuItemSelection) {
        this.selectionPrices = selection.menuSelection.prices;
    }
}
